import { Component, OnInit, QueryList, ViewChild, ViewChildren } from "@angular/core";
import { BreadCrumbModel } from "app/views/campaign-3/models/campaign-3-breadcrumb.model";
import { ChallengeService } from "../challenge.service";
import { ChallengeDetail, ChallengeDetailAcm, ChallengeDetailElaborated, ChallengeResponse } from "../challenge.model";
import { ActivatedRoute, Router } from "@angular/router";
import { LoyaltyAcmService } from "app/services/loyalty/loyalty-acm.service";
import { Observable } from "rxjs";
import { Acm } from "app/models/loyalty-acm.model";
import { DistributionList3 } from "app/views/campaign-3/models/campaign-3.model";
import { DistributionList3Service } from "app/views/distribution-list/services/distribution3.service";
import { Campaign3Service } from "app/views/campaign-3/services/campaign3.service";
import { MessageService } from "primeng/primeng";
import { TranslateService } from "@ngx-translate/core";
import { FormFields } from "app/views/campaign-3/components/form-fields/form-fields.component";
import { ChallengeEditResponse } from "../challenge-creation/challenge-creation.component";
import * as moment from "moment";




interface Premio {
  tipoForm: 'accumulatore' | 'cluster';
  description: string;
  tipologia: { label: string; value: string } | null;
  accumulatore: {
    expired: { description: string; id: number; acmTypeId: number; }; description: string; id: number, acmTypeId: number
  } | null;
  causale: any | null;
  causali?: { label: string; value: any }[];
  reasonDisabled?: boolean;
  cluster: any | null;
  operazione: any | null;
  valore: number | null;
  long_descr?: string;
  challenge_detail_id?: number;
  challenge_reward_id?: number;
  cluster_date_end_type: { label: string, value: string } | null;
  cluster_date_end: Date | null;

}



export interface PremioDTO {
  challenge_detail_id: number;
  description: string;
  acm_id: number;
  acm_value: number;
  acm_reason_id: number;
  cluster_head_id: number;
  cluster_operation: number | null;
  long_descr: string;
  challenge_reward_id?: number;
  cluster_date_end_type: string;
  cluster_date_end: string | null;
}



@Component({
  selector: 'app-gifts-edit-create',
  templateUrl: './gifts-edit-create.component.html',
  styleUrls: ['./gifts-edit-create.component.css']
})
export class GiftsEditCreateComponent implements OnInit {


  @ViewChildren('premioDescription') premioDescriptions: QueryList<FormFields>;
  @ViewChildren('premioTipologia') premioTipologie: QueryList<FormFields>;
  @ViewChildren('premioTipoForm') premioTipoForms: QueryList<FormFields>;
  @ViewChildren('premioAccumulatore') premioAccumulatori: QueryList<FormFields>;
  @ViewChildren('premioCausale') premioCausali: QueryList<FormFields>;
  @ViewChildren('premioCluster') premioCluster: QueryList<FormFields>;
  @ViewChildren('premioOperazione') premioOperazioni: QueryList<FormFields>;
  @ViewChildren('premioValore') premioValori: QueryList<FormFields>;
  @ViewChildren('premioClusterDateEndType') premioClusterDateEndTypes: QueryList<FormFields>;


  show = {
    modalAcmList: false,

  }
  today: Date

  breadcrumbs: Array<BreadCrumbModel> = [];
  editMode: boolean = false;
  singleChallenge: ChallengeResponse;
  provTitle: string = ''
  currentDistributionListId
  idSingleChallenge: any;
  listAccumulator: any[] = [];
  clusterList: any[] = [];
  touchpointList: any[] = [];
  //selectedAcm: Acm[] = [];
  showTable = false;
  distributionList: DistributionList3[] = [];
  showBreadCrumb: boolean = false;
  selectedDistributionList: DistributionList3;
  levelId: string | null = null;
  currentLevel: ChallengeDetailElaborated;
  editGiftResponse: any[];
  readOnly: boolean = false;


  constructor(
    private challengeService: ChallengeService,
    public router: Router,
    private srvLoyaltyAcm: LoyaltyAcmService,
    private distributionService: DistributionList3Service,
    private srvNotify: MessageService,
    private translate: TranslateService,
    private route: ActivatedRoute,
    public campaignService: Campaign3Service,

  ) { }

  currentChallengeId: number;
  currentLevelId: number;

  premiList: Premio[] = [];
  tipologiePremio = [
    { label: '', value: null },
    { label: 'Accumulatore', value: 'accumulatore' },
    { label: 'Cluster', value: 'cluster' },
  ];

  clusterDateEndTypeOptions: { label: string; value: string }[] = [];

  operazioni = [];
  breadcrumbClicked(breadcrumb: BreadCrumbModel) {
    if (breadcrumb.routerLink) {
      this.router.navigate([breadcrumb.routerLink]);
    }
  }
  private initFormPremi(premiDtoList: any[]): void {
    // Caso base → lista vuota
    if (!premiDtoList || premiDtoList.length === 0) {
      this.premiList = [];
      return;
    }

    this.premiList = premiDtoList.map((premioDto: any) => {

      // ------------------------  
      // 1. Estrazione ACM ID
      // ------------------------
      let acmId: any = null;
      if (premioDto.acm_id) {
        if (premioDto.acm_id.id) {
          acmId = premioDto.acm_id.id;
        } else {
          acmId = premioDto.acm_id;
        }
      }

      // ------------------------  
      // 2. Accumulatore corrispondente
      // ------------------------
      let accumulatore: any = null;
      for (let i = 0; i < this.listAccumulator.length; i++) {
        const item = this.listAccumulator[i];
        if (item.id === acmId) {
          accumulatore = {
            description: item.acmDescription ? item.acmDescription : '',
            id: item.id != null ? item.id : null,
            acmTypeId: item.acm_type_id != null ? item.acm_type_id : null
          };
          break;
        }
      }

      // Accumulatore scaduto e filtrato via: costruiamo un placeholder
      // per evitare crash e segnalare il problema in UI
      if (accumulatore === null && acmId !== null) {
        accumulatore = {
          description: this.translate.instant('challenge.accumulator_expired_or_not_found'),
          id: acmId,
          acmTypeId: null,
          expired: true
        };

        this.srvNotify.add({
          severity: 'warn',
          summary: this.translate.instant('common.warning'),
          detail: this.translate.instant('challenge.accumulator_expired_warning')
        });
      }

      // ------------------------  
      // 3. Cluster ID e cluster object
      // ------------------------
      let cluster: any = null;
      let clusterId: any = null;

      if (
        premioDto &&
        premioDto.cluster_head_id &&
        premioDto.cluster_head_id.id != null
      ) {
        clusterId = premioDto.cluster_head_id.id;
      }

      if (clusterId !== null) {
        for (let i = 0; i < this.clusterList.length; i++) {
          if (this.clusterList[i].value === clusterId) {
            cluster = this.clusterList[i];
            break;
          }
        }
      }

      // ------------------------  
      // 4. Operazione
      // ------------------------
      //TODO
      const clusterOperation = premioDto.cluster_operation != null
        ? String(premioDto.cluster_operation)
        : null;
      let operazione: any = null;

      for (let i = 0; i < this.operazioni.length; i++) {
        if (this.operazioni[i].value === clusterOperation) {
          operazione = this.operazioni[i];
          break;
        }
      }

      // ------------------------  
      // 5. Tipo form / tipologia
      // ------------------------
      const tipoForm: 'accumulatore' | 'cluster' =
        acmId != null ? 'accumulatore' : 'cluster';

      let tipologia: any = null;
      for (let i = 0; i < this.tipologiePremio.length; i++) {
        if (this.tipologiePremio[i].value === tipoForm) {
          tipologia = this.tipologiePremio[i];
          break;
        }
      }

      let clusterDateTypeObj = null;
      console.log(`Premio ID ${premioDto.challenge_detail_id} - Tipo Data dal DB:`, premioDto.cluster_date_end_type);
      if (premioDto.cluster_date_end_type) {
        const tipoDb = String(premioDto.cluster_date_end_type).trim().toUpperCase();
        clusterDateTypeObj = this.clusterDateEndTypeOptions.find(opt => opt.value === tipoDb) || null;
      }
      
      if (!clusterDateTypeObj) {
        clusterDateTypeObj = null;
      }
      // ------------------------  
      // 6. Oggetto premio base
      // ------------------------
      const premio: Premio = {
        challenge_detail_id: premioDto.challenge_detail_id != null ? premioDto.challenge_detail_id : 0,

        description: premioDto.description ? premioDto.description : '',
        tipologia: tipologia,
        tipoForm: tipoForm,
        accumulatore: accumulatore,

        valore: premioDto.acm_value != null ? premioDto.acm_value : null,

        causale: null,
        causali: [],
        reasonDisabled: null,

        cluster: cluster,
        operazione: operazione,

        long_descr: premioDto.long_descr ? premioDto.long_descr : '',

        challenge_reward_id: premioDto.challenge_reward_id != null
          ? premioDto.challenge_reward_id
          : null,
        cluster_date_end_type: clusterDateTypeObj,
        cluster_date_end: premioDto.cluster_date_end ? new Date(premioDto.cluster_date_end) : undefined
      };

      // ------------------------  
      // 7. Causali in base all'ACM Type
      // ------------------------
      if (accumulatore && accumulatore.acmTypeId != null) {

        premio.reasonDisabled = false;

        this.challengeService.getFromAcmType(accumulatore.acmTypeId).subscribe({
          next: (res: any) => {
            if (res && Array.isArray(res.data) && res.data.length > 0) {

              premio.causali = res.data.map(function (item: any) {
                return {
                  label: item.short_description ? item.short_description : '',
                  value: item.reason_id != null ? item.reason_id : null
                };
              });

              // Record vuoto
              premio.causali.unshift({ label: '', value: null });

              // Selezione causale pre-esistente
              let causaleTrovata: any = null;
              for (let i = 0; i < premio.causali.length; i++) {
                if (premio.causali[i].value === premioDto.acm_reason_id) {
                  causaleTrovata = premio.causali[i];
                  break;
                }
              }

              premio.causale = causaleTrovata;
            } else {
              premio.causali = [{ label: '', value: null }];
              premio.causale = null;
              premio.reasonDisabled = true;
            }
          },

          error: (err: any) => {
            console.error('Errore nel recupero causali per ACM type:', accumulatore.acmTypeId, err);
            premio.causali = [{ label: '', value: null }];
          }
        });

      } else {
        // Nessun accumulatore
        premio.causali = [{ label: '', value: null }];
      }

      return premio;
    });

    console.log('✅ Premi ripopolati sul form:', this.premiList);
  }


  private evaluateReadOnly(): void {
    let readOnly = true; // default totale di sicurezza

    this.challengeService.getChallengeById(this.currentChallengeId)
      .subscribe(
        res => {
          let challenge = null;

          // Recupero challenge da res senza optional chaining
          if (res && res.data && res.data[0]) {
            challenge = res.data[0];
          }

          if (challenge) {
            const status = challenge.status ? Number(challenge.status) : null;
            const dateStart = challenge.dateStart ? new Date(challenge.dateStart) : null;
            const now = new Date();

            // LOGICA:
            // 0 → Pubblicata → sempre readOnly
            // 4 → Pubblicazione annullata
            //          se non è ancora iniziata → modificabile
            //          se è iniziata → readOnly
            // altri stati → sempre modificabile

            if (status === 0) {
              readOnly = true;

            } else if (status === 4) {

              if (dateStart) {
                if (now >= dateStart) {
                  readOnly = true;
                } else {
                  readOnly = false;
                }
              } else {
                readOnly = true;
              }

            } else {
              readOnly = false;
            }
          }

          this.readOnly = readOnly;
        },
        err => {
          // In caso di errore → rimane il default (true)
          this.readOnly = readOnly;
        }
      );
  }

  ngOnInit(): void {
    this.today = new Date();



    const challengeIdParam = this.route.snapshot.queryParamMap.get('challengeId');
    const levelIdParam = this.route.snapshot.queryParamMap.get('levelId');

    const challengeId = challengeIdParam ? Number(challengeIdParam) : null;
    const levelId = levelIdParam ? Number(levelIdParam) : null;

    if (!challengeId) {
      this.router.navigate(['/challenge-list']);
      return;
    }

    this.currentChallengeId = challengeId;
    this.evaluateReadOnly();

    if (levelId) {
      this.currentLevelId = levelId;
      this.challengeService.getGiftsDetailIfPresent(challengeId, levelId).subscribe(res => {
        if (res && res.length > 0) {
          this.editGiftResponse = res;
          console.log(res);
          this.editMode = true;
        } else {
          this.editMode = false;
        }
      });
    } else {
      console.log("attenzione manca l'id del livello");
    }

    const CHALLENGE = this.challengeService.getChallengeById(challengeId);
    const LISTA_ACCUMULATORI = this.srvLoyaltyAcm.getAllAcm();
    const CLUSTER_LIST = this.challengeService.getClusterHeadAllListWithParams();
    const DISTR_LIST = this.distributionService.list();
    const TOUCH_LIST = this.challengeService.getTouchPoints();

    var self = this;

    Observable.zip(
      CHALLENGE,
      LISTA_ACCUMULATORI,
      CLUSTER_LIST,
      DISTR_LIST,
      TOUCH_LIST
    ).subscribe(([challenge, res_acc, res_clust, distrList, touchList]) => {

      const challengeData: ChallengeResponse | null =
        challenge && challenge.data && challenge.data.length > 0
          ? challenge.data[0]
          : null;

      const challengeStatus = challengeData && challengeData.status != null
        ? Number(challengeData.status)
        : null;

      const isDraft = challengeStatus === 2;

      this.operazioni = [
        { label: '', value: null },
        { label: this.translate.instant('challenge.add'), value: 'ADD' },
        { label: this.translate.instant('challenge.remove'), value: 'REMOVE' },
      ];

      this.clusterDateEndTypeOptions = [
        { label: '', value: null },
        { label: this.translate.instant('challenge.cluster_dynamic'), value: 'D' },
        { label: this.translate.instant('challenge.cluster_static'), value: 'S' },
      ];

      if (res_acc) {
        const cloned = JSON.parse(JSON.stringify(res_acc));
        this.listAccumulator = this.filterValidAccumulators(cloned, isDraft);
      }

      if (res_clust) {
        this.clusterList = res_clust.map((element: any) => {
          return {
            label: element.clusterDescription,
            value: element.clusterHeadId,
            date_end: element.date_end ? new Date(element.date_end) : null
          };
        });
        this.clusterList.unshift({ label: '', value: null });
        console.log(this.clusterList);
      }

      if (distrList) {
        self.distributionList = distrList.data;
      }

      if (touchList) {
        this.touchpointList = touchList.map((t: any) => ({
          ...t,
          active: false
        }));
      }

      if (this.editMode) {
        this.initFormPremi(this.editGiftResponse);
      }

      this.initBreadCrumbs();
      this.showTable = true;
    });
  }

  private filterValidAccumulators(accumulators: any[], isDraft: boolean): any[] {
    let filtered = [];

    if (accumulators) {
      if (!isDraft) {
        filtered = accumulators;

      } else {

        for (let i = 0; i < accumulators.length; i++) {
          const acc = accumulators[i];
          const dEnd = acc && acc.dateEnd ? new Date(acc.dateEnd) : null;

          if (!dEnd || dEnd >= this.today) {
            filtered.push(acc);
          }
        }
      }
    }

    return filtered;
  }
  //decidere quale tipo di premio voglio inserire tra le due tipologie
  aggiungiPremio(tipo: 'accumulatore' | 'cluster') {
    const tipologiaSelezionata = tipo; // 'accumulatore' o 'cluster'

    this.premiList.push({
      tipoForm: tipo, // chiave per capire che form mostrare
      description: '',
      tipologia: { label: tipologiaSelezionata.charAt(0).toUpperCase() + tipologiaSelezionata.slice(1), value: tipologiaSelezionata },
      accumulatore: { description: '', id: null, acmTypeId: null, expired: null },

      causale: null,
      cluster: null,
      operazione: null,
      reasonDisabled: true,
      valore: null,
      cluster_date_end_type: null,
      cluster_date_end: undefined
    });
  }

  rimuoviPremio(index: number) {
    this.premiList.splice(index, 1);
  }
  //cambio di acm devo chiamare la lista delle causali
  onChangeAcm(acm: any, index: number): void {
    if (!acm || !acm.acmTypeId) {
      console.warn('ACM non valido:', acm);
      this.premiList[index].causali = []
      this.premiList[index].reasonDisabled = true;
      /*  this.causali = [];
       this.reasonDisabled = true; */
      return;
    }

    const acmTypeId = acm.acmTypeId;
    this.premiList[index].reasonDisabled = false;
    this.challengeService.getFromAcmType(acmTypeId).subscribe({
      next: (res: any) => {
        if (res && Array.isArray(res.data) && res.data.length > 0) {
          // Mappiamo le causali
          this.premiList[index].causali = res.data.map(function (item: any) {
            return {
              label: item.short_description ? item.short_description : '',
              value: item.reason_id != null ? item.reason_id : null
            };
          });

          // 🔹 Aggiungiamo un record vuoto come prima opzione
          this.premiList[index].causali.unshift({ label: '', value: null });

          this.premiList[index].reasonDisabled = false;
        } else {
          console.warn('Nessuna causale trovata per ACM type:', acmTypeId);
          this.premiList[index].causali = [{ label: '', value: null }]; // record vuoto anche in caso di risposta vuota
          this.premiList[index].reasonDisabled = true;
          this.premiList[index].causale = null;
        }
      },
      error: (err: any) => {
        console.error('Errore nel recupero delle causali per ACM type', acmTypeId, err);
        this.premiList[index].causali = [{ label: '', value: null }]; // record vuoto in caso di errore
        this.premiList[index].reasonDisabled = true;
        this.premiList[index].causale = null;

      }
    });

  }


  onSaveGifts() {
    const isValid = this.validatePremi();

    if (!isValid) {
      console.error('Ci sono errori nella validazione dei premi');
      return;
    }
    // Trasformiamo la lista dei premi nel formato richiesto dal backend
    const payload: PremioDTO[] = this.premiList.map(premio => ({
      challenge_detail_id: this.currentLevelId,
      description: premio && premio.description ? premio.description : '',
      acm_id: premio && premio.accumulatore ? premio.accumulatore.id : null,
      acm_value: premio && premio.valore != null ? premio.valore : null,
      acm_reason_id: premio && premio.causale ? premio.causale.value : null,
      cluster_head_id: premio && premio.cluster ? premio.cluster.value : null,
      cluster_operation: premio && premio.operazione ? premio.operazione.value : null,
      long_descr: '',
      challenge_reward_id: premio.challenge_reward_id ? premio.challenge_reward_id : null,
      cluster_date_end_type: premio.cluster_date_end_type ? premio.cluster_date_end_type.value : null,
      cluster_date_end: premio.cluster_date_end ? moment(premio.cluster_date_end).format('YYYY-MM-DD') : null
    }));

    console.log('Payload da inviare:', payload);
    if (!this.editMode) {
      this.challengeService.createChallengeGifts(payload).subscribe({
        next: res => {
          console.log('Premi salvati con successo', res);
          this.srvNotify.add({
            severity: 'success',
            summary: this.translate.instant('common.success'),
            detail: this.translate.instant('challenge.gift_created')
          });
          this.router.navigate(['/challenge-list'], {
            queryParams: { challengeId: this.currentChallengeId }
          });
        },
        error: err => console.error('Errore nel salvataggio dei premi', err)
      });
    } else {
      this.challengeService.createChallengeGifts(payload).subscribe({
        next: res => {
          console.log('Premi editati con successo', res);
          this.srvNotify.add({
            severity: 'success',
            summary: this.translate.instant('common.success'),
            detail: this.translate.instant('challenge.gift_edited')
          });
          this.router.navigate(['/challenge-list'], {
            queryParams: { challengeId: this.currentChallengeId }
          });
        },
        error: err => console.error('Errore in editing dei premi', err)
      });
    }

  }



  validatePremi(): boolean {
    let error = false;

    // 1. Estraiamo gli array dai ViewChildren (escluso quello della data)
    const descArr = this.premioDescriptions ? this.premioDescriptions.toArray() : [];
    const tipArr = this.premioTipologie ? this.premioTipologie.toArray() : [];
    const accArr = this.premioAccumulatori ? this.premioAccumulatori.toArray() : [];
    const causArr = this.premioCausali ? this.premioCausali.toArray() : [];
    const clusterArr = this.premioCluster ? this.premioCluster.toArray() : [];
    const operArr = this.premioOperazioni ? this.premioOperazioni.toArray() : [];
    const valArr = this.premioValori ? this.premioValori.toArray() : [];
    const clusterDateEndTypeArr = this.premioClusterDateEndTypes ? this.premioClusterDateEndTypes.toArray() : [];

    for (let i = 0; i < this.premiList.length; i++) {
      const premio = this.premiList[i];

      const descField = descArr[i];
      const tipField = tipArr[i];
      const accField = accArr[i];
      const causField = causArr[i];
      const clusterField = clusterArr[i];
      const operField = operArr[i];
      const valField = valArr[i];
      const clusterDateEndTypeField = clusterDateEndTypeArr[i];

      // 2. Eseguiamo performValidation sui campi standard di app-form-fields
      if (descField != null) descField.performValidation();
      if (tipField != null) tipField.performValidation();
      if (accField != null) accField.performValidation();
      if (causField != null) causField.performValidation();
      if (clusterField != null) clusterField.performValidation();
      if (operField != null) operField.performValidation();
      if (valField != null) valField.performValidation();
      if (clusterDateEndTypeField != null) clusterDateEndTypeField.performValidation();

      // 3. Verifica validità generale
      if (
        (descField != null && !descField.valid) ||
        (tipField != null && !tipField.valid) ||
        (accField != null && !accField.valid) ||
        (causField != null && !causField.valid) ||
        (clusterField != null && !clusterField.valid) ||
        (operField != null && !operField.valid) ||
        (valField != null && !valField.valid) ||
        (clusterDateEndTypeField != null && !clusterDateEndTypeField.valid)
      ) {
        error = true;
      }

      // 4. Controlli extra specifici per l'accumulatore
      if (valField != null && valField.valid) {
        if (premio.tipoForm === 'accumulatore' && (premio.valore === null || premio.valore === undefined || premio.valore <= 0)) {
          error = true;
          valField.errorMessage = this.translate.instant('challenge.valore_positive_error');
          console.warn(`Premio ${i}: valore deve essere maggiore di 0`);
        }
      }

      // 5. NUOVO CONTROLLO MANUALE PER IL CALENDARIO (p-calendar)
      if (premio.tipoForm === 'cluster' && premio.cluster_date_end_type && premio.cluster_date_end_type.value === 'S') {
        // Se la tipologia è statica, la data è obbligatoria. Verifichiamo che esista.
        if (!premio.cluster_date_end) {
          error = true;

          // Mostriamo un avviso a schermo per far capire all'utente dove manca il dato
          this.srvNotify.add({
            severity: 'error',
            summary: this.translate.instant('common.error'),
            detail: `Premio ${i + 1}: la data di fine validità è obbligatoria.`
          });

          console.warn(`Premio ${i}: data fine validità obbligatoria per tipologia statica`);
        }
      }
    }

    return !error;
  }

  //carichiamo tutte le liste necessarie

  currentLevelAcmId: number

  private initBreadCrumbs(): void {
    this.breadcrumbs = [
      {
        code: 'bc1',
        description: this.translate.instant('challenge.challenge-list'),
        routerLink: '/challenge-list'
      },
      {
        code: 'bc2',
        description: this.translate.instant('breadCrumb.rewards_creation'),
        routerLink: '/levels-creation'
      }
    ].map(bc => {
      const breadcrumb = new BreadCrumbModel();
      breadcrumb.code = bc.code;
      breadcrumb.description = bc.description;
      breadcrumb.routerLink = bc.routerLink;
      return breadcrumb;
    });

    this.showBreadCrumb = this.breadcrumbs.length > 0;
  }

  // validità della Data Fine Cluster
  getClusterMaxDate(cluster: any): Date | null {
    return (cluster && cluster.date_end) ? new Date(cluster.date_end) : null;
  }

  onBackAction(): void {
    this.router.navigate(['/challenge-list'], {
      queryParams: { challengeId: this.currentChallengeId }
    });
  }

  get canSave(): boolean {
    return this.premiList && this.premiList.length > 0;
  }
  //modale acm
  indexAccumulator: number = null;
  onAddAccumulator(index: number): void {
    this.indexAccumulator = index;
    this.show.modalAcmList = true;
  }

  onAcmSelected(acm: any[]): void {

    // chiudi subito se non ricevi nulla
    if (!acm || !Array.isArray(acm) || acm.length === 0) {
      this.show.modalAcmList = false;
      return;
    }

    const selected = acm[0];
    const premio = this.premiList[this.indexAccumulator];

    if (!premio) {
      this.show.modalAcmList = false;
      return;
    }

    // assicuriamo che accumulatore esista
    if (!premio.accumulatore) {
      premio.accumulatore = {
        description: '',
        id: null,
        acmTypeId: null,
        expired: null,
      };
    }

    // --- MAPPING ACCUMULATORE ---
    premio.accumulatore.description =
      selected && selected.acmDescription ? selected.acmDescription : '';

    premio.accumulatore.id =
      selected && selected.id ? selected.id : null;

    premio.accumulatore.acmTypeId =
      selected && selected.acm_type_id ? selected.acm_type_id : null;

    premio.accumulatore.expired = null; // ← reset flag scaduto


    // --- LOGICA ex-onChangeAcm ---
    // Se acmTypeId non c’è → reset
    if (!selected || !selected.acm_type_id) {
      console.warn('ACM non valido:', selected);
      premio.causali = [];
      premio.reasonDisabled = true;
      premio.causale = null;
      this.show.modalAcmList = false;
      return;
    }

    const acmTypeId = selected.acm_type_id;

    premio.reasonDisabled = false;

    this.challengeService.getFromAcmType(acmTypeId).subscribe({
      next: (res: any) => {

        if (res && Array.isArray(res.data) && res.data.length > 0) {

          premio.causali = res.data.map(function (item: any) {
            return {
              label: item && item.short_description ? item.short_description : '',
              value: item && item.reason_id != null ? item.reason_id : null
            };
          });

          // aggiungo entry vuota
          premio.causali.unshift({ label: '', value: null });

          premio.reasonDisabled = false;

        } else {
          console.warn('Nessuna causale trovata per ACM type:', acmTypeId);
          this.srvNotify.add({
            severity: 'warn',
            summary: this.translate.instant('common.warning'),
            detail: this.translate.instant('challenge.accumulator_reason_not_found')
          });
          premio.causali = [{ label: '', value: null }];
          premio.reasonDisabled = true;
          premio.causale = null;
        }

      },
      error: (err: any) => {
        console.error('Errore nel recupero delle causali per ACM type', acmTypeId, err);

        premio.causali = [{ label: '', value: null }];
        premio.reasonDisabled = true;
        premio.causale = null;
      }
    });

    this.show.modalAcmList = false;
  }

  get hasExpiredAccumulators(): boolean {
    if (!this.premiList || this.premiList.length === 0) {
      return false;
    }
    for (let i = 0; i < this.premiList.length; i++) {
      const premio = this.premiList[i];
      if (premio.accumulatore && premio.accumulatore.expired) {
        return true;
      }
    }
    return false;
  }
}



// WEBPACK FOOTER //
// ./src/app/views/challenge/gifts/gifts-edit-create.component.ts